// extracted by mini-css-extract-plugin
module.exports = {"emptyTip":"index_emptyTip__gcqusbCB","root":"index__gcqusbCB","empty":"index_empty__gcqusbCB"};